module.exports = __webpack_public_path__ + "media/scholarship_winners/linda-sw-b818e21c.png";